<template>
  <div class="md-layout" >
    <!-- 主菜单表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <div class="md-layout" style="max-width: 500px;">
            <div class="md-layout-item md-size-50 left-layout-item md-xsmall-size-100">
              <md-field>
                <label>{{$I18n("product")}}</label>
                <md-select v-model="searchForm">
                  <md-option v-for="item in classData" :key="item.id" :value="item.id">{{item.name}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50 left-layout-item md-xsmall-size-100">
              <md-field>
                <label>{{$I18n("company")}}</label>
                <md-select v-model="searchFormCompany">
                  <md-option v-for="item in compData" :key="item.comp_id" :value="item.comp_id">{{item.comp_name}}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <add-button @click="table_addItem" v-if="UserInfo.role_id < 10000">{{$I18n("add_good")}}</add-button>
          <md-table v-model="tableData" >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sys_name')">
                <div v-if="item.is_set_name == 1" style="cursor: pointer;color: #00bcd4;" @click="changeItem(item, 'name', $I18n('sys_name'))">
                  {{ item.name }}
                </div>
                <div v-else>{{item.name}}</div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('cus_name')">
                <div style="cursor: pointer;color: #00bcd4;" @click="changeItem(item, 'custom_name', $I18n('cus_name'))">
                  {{ item.custom_name }}
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('company_name')">{{ item.comp_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('effect_month')">{{ item.month }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cost_price')">
                <div v-if="item.is_set_cost_price == 1" style="cursor: pointer;color: #00bcd4;" @click="changeItem(item, 'cost_price', $I18n('cost_price'))">
                  <p :style="{'margin':0}" v-for="i in item._cost_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
                </div>
                <div v-else>
                  <p :style="{'margin':0}" v-for="i in item._cost_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('list_price')">
                <div style="cursor: pointer;color: #00bcd4;" @click="changeItem(item, 'list_price', $I18n('list_price'))">
                  <p :style="{'margin':0}" v-for="i in item._list_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('retail_price')">
                <div style="cursor: pointer;color: #00bcd4;" @click="changeItem(item, 'final_price', $I18n('retail_price'))">
                  <p :style="{'margin':0}" v-for="i in item._final_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('list_state')">
                <div style="margin-left: 8px;position: relative;">
                  <md-switch class="small-switch" v-model="item._state_name"/>
                  <div style="position: absolute;top: -16px;bottom: -16px;left: 0;right: 0;z-index: 10;cursor: pointer;" @click="switchState(item)"></div>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')" class="button-box">
                <template v-if="item.name">
                  <el-dropdown trigger="click" class="left-icon" @command="(command) => handleCommand(command, item)">
                    <md-button
                      class="md-just-icon md-round md-info "
                      ><md-icon>edit</md-icon></md-button
                    >
                    <!-- 下拉菜单 -->
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="edit" v-if="UserInfo.role_id < 10000">{{$I18n("edit_prod")}}</el-dropdown-item>
                      <el-dropdown-item command="assi">{{$I18n("assi_prod")}}</el-dropdown-item>
                      <el-dropdown-item command="allo">{{$I18n("allo_detail")}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <md-button
                    @click.stop="table_deleteItem(item)"
                    class="md-just-icon md-round md-danger md-info"
                    ><md-icon>close</md-icon></md-button
                  >
                </template>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal
      class="bold-title"
      ref = "allo_modal"
      :title="$I18n('allo_detail')"
      :right="true"
      :large="false"
      :submitBtn="false"
      @close="() => {alloInfo = {};alloTableData = [];alloTotal = 0;}"
    >
      <div slot="body" style="text-align: left;">
        <div style="">
          <div style="display: flex;padding-bottom: 10px;margin-bottom: 5px;padding-left: 8px;">
            <div class="allo_item">
              <p class="allo_label">{{$I18n('sys_name')}}</p>
              <p>{{alloInfo.name}}</p>
            </div>
            <div class="allo_item">
              <p class="allo_label">{{$I18n('cus_name')}}</p>
              <p>{{alloInfo.custom_name}}</p>
            </div>
          </div>
          <div style="display: flex;padding-left: 8px;">
            <div class="allo_item">
              <p class="allo_label">{{$I18n('cost_price')}}</p>
              <ul v-if="alloInfo._cost_price_list">
                <li :key="'cost_' + item.key" v-for="item in alloInfo._cost_price_list">{{item.key}}: {{item.value}}</li>
              </ul>
            </div>
            <div class="allo_item">
              <p class="allo_label">{{$I18n('list_price')}}</p>
              <ul v-if="alloInfo._list_price_list">
                <li :key="'list_' + item.key" v-for="item in alloInfo._list_price_list">{{item.key}}: {{item.value}}</li>
              </ul>
            </div>
            <div class="allo_item">
              <p class="allo_label">{{$I18n('retail_price')}}</p>
              <ul v-if="alloInfo._final_price_list">
                <li :key="'final_' + item.key" v-for="item in alloInfo._final_price_list">{{item.key}}: {{item.value}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div style="margin-top:20px;padding-left: 8px;font-size: 18px;font-weight: 600;">{{$I18n("allo_detail")}}</div>
        <md-table v-model="alloTableData" md-model-id="comp_name">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell :md-label="$I18n('company_name')">{{ item.comp_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('cost_price')">
              <div v-if="item.is_set_cost_price == 1" style="cursor: pointer;color: #00bcd4;" @click="changeItem(item, 'cost_price', $I18n('cost_price'), alloInfo._cost_price_list)">
                <p :style="{'margin':0}" v-for="i in item._cost_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
              </div>
              <div v-else>
                <p :style="{'margin':0}" v-for="i in item._cost_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
              </div>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('list_price')">
              <div style="cursor: pointer;color: #00bcd4;" @click="changeItem(item, 'list_price', $I18n('list_price'))">
                <p :style="{'margin':0}" v-for="i in item._list_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
              </div>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('retail_price')">
              <div style="cursor: pointer;color: #00bcd4;" @click="changeItem(item, 'final_price', $I18n('retail_price'))">
                <p :style="{'margin':0}" v-for="i in item._final_price_list" :key="i.key">{{i.key}}: {{i.value}}</p>
              </div>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('list_state')">
              <div style="margin-left: 8px;position: relative;">
                <md-switch class="small-switch" v-model="item._state_name"/>
                <div style="position: absolute;top: -16px;bottom: -16px;left: 0;right: 0;z-index: 10;cursor: pointer;" @click="switchBoldState(item)"></div>
              </div>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('allo_date')">{{ item.create_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('operate')" style="min-width: 80px;">
              <md-button
                @click.stop="table_deleteItem(item)"
                class="md-just-icon md-round md-danger md-info"
                ><md-icon>close</md-icon></md-button
              >
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">
            {{$I18n("none_data")}}
          </md-table-empty-state>
        </md-table>
        <!-- 翻页 -->
        <table-page :total="alloTotal" :pageSize="alloPageSize" v-model="alloPageNo"/>
      </div>
    </simple-modal>
    <simple-modal
      ref = "key_modal"
      :title="keyTitle"
      :right="false"
      :large="false"
      @submit="key_submit"
      @close="closeModal"
    >
      <div slot="body">
        <common-form-item v-if="keyModalType == 'name' || keyModalType == 'custom_name'" v-model="keyInput" type="input"/>

        <!-- 添加一个新的 -->
        <div v-else>
          <div class="md-layout-item mx-auto md-size-100" v-for="(formItem, index) in keyList" :key="formItem.key" style="margin-left: 0 !important;">
            <md-card :style="{'margin-bottom':'5px'}">
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-25">
                    <md-field>
                      <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                        <md-option value="">{{$I18n("currency")}}</md-option>
                        <md-option v-for="item in key_attrOption(formItem.key)" :key="item" :value="item" >
                          {{item}}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item" :class="{
                    'md-size-65': !(assiDataBase_v2 && assiDataBase_v2.length > 0),
                    'md-size-75': (assiDataBase_v2 && assiDataBase_v2.length > 0),
                  }">
                    <!-- INPUT -->
                    <md-field>
                      <md-input v-model="formItem.value"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-10" v-if="!(assiDataBase_v2 && assiDataBase_v2.length > 0)">
                    <md-button 
                      @click="keyList.splice(index,1)" 
                      :style="{'float':'right'}"
                      class="md-primary md-sm md-info right-button md-just-icon md-round"
                    >
                      <md-icon>close</md-icon>
                    </md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
      <div slot="footer-btn" v-if="keyModalType != 'name' && keyModalType != 'custom_name'">
        <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left'}" v-if="!(assiDataBase_v2 && assiDataBase_v2.length > 0) && UserInfo.role_id < 10000">
          <md-button class="md-info" @click="keyList.push({key:'',value:''})">{{$I18n("add")}}</md-button>
        </div>
      </div>
    </simple-modal>
    <simple-modal
      ref = "assi_modal"
      :title="$I18n('assi_prod')"
      :right="false"
      :large="false"
      @submit="assi_submit"
      @close="closeModal"
    >
      <div slot="body" class="md-layout-item md-layout md-size-100" style="max-height: calc(100vh - 240px);overflow: auto;">
        <div class="md-layout-item mx-auto md-size-50" :style="{'text-align':'left','padding-left':0,'padding-right':0}">
          <common-form-item :label="$I18n('company')" v-model="assiData.Form.comp_path" :options="assiComp" type="select"/>
        </div>
        <div class="md-layout-item mx-auto md-size-50" :style="{'text-align':'left','padding-left':0,'padding-right':0}">
          <common-form-item :label="$I18n('online_state_02')" v-model="assiData.Form._state_name" type="switch"/>
        </div>
        <!--  -->
        <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left','margin-top': '30px','display':'flex'}">
          <span class="md-form-label" style="padding-top: 0;">{{$I18n("cost_price")}}<i style="color: red;">*</i></span>
        </div>
        <div class="md-layout-item mx-auto md-size-100" v-for="(formItem, index) in assiData.Form._cost_price_list" :key="'cost' + index" style="margin-left: 0 !important;">
          <md-card :style="{'margin-bottom':'5px'}">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-25">
                  <md-field>
                    <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                      <md-option value="">{{$I18n("currency")}}</md-option>
                      <md-option v-for="item in assi_cost_attrOption(formItem.key)" :key="item" :value="item" >
                        {{item}}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-75">
                  <!-- INPUT -->
                  <md-field>
                    <md-input v-model="formItem.value"/>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <!--  -->
        <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left','margin-top': '30px','display':'flex'}">
          <span class="md-form-label" style="padding-top: 0;">{{$I18n("list_price")}}<i style="color: red;">*</i></span>
          <div @click="assiData.Form._list_price_list.push({key:'',value:''})" :style="{'background':'#FFF','cursor': 'pointer','margin-left':'10px'}">
            <icon-add/>
          </div>
        </div>
        <div class="md-layout-item mx-auto md-size-100" v-for="(formItem, index) in assiData.Form._list_price_list" :key="'list' + index" style="margin-left: 0 !important;">
          <md-card :style="{'margin-bottom':'5px'}">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-25">
                  <md-field>
                    <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                      <md-option value="">{{$I18n("currency")}}</md-option>
                      <md-option v-for="item in assi_list_attrOption(formItem.key)" :key="item" :value="item" >
                        {{item}}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-65">
                  <!-- INPUT -->
                  <md-field>
                    <md-input v-model="formItem.value"/>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-10">
                  <md-button 
                    @click="assiData.Form._list_price_list.splice(index,1)" 
                    :style="{'float':'right'}"
                    class="md-primary md-sm md-info right-button md-just-icon md-round"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <!--  -->
        <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left','margin-top': '30px','display':'flex'}">
          <span class="md-form-label" style="padding-top: 0;">{{$I18n("retail_price")}}<i style="color: red;">*</i></span>
          <div @click="assiData.Form._final_price_list.push({key:'',value:''})" :style="{'background':'#FFF','cursor': 'pointer','margin-left':'10px'}">
            <icon-add/>
          </div>
        </div>
        <div class="md-layout-item mx-auto md-size-100" v-for="(formItem, index) in assiData.Form._final_price_list" :key="'final' + index" style="margin-left: 0 !important;">
          <md-card :style="{'margin-bottom':'5px'}">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-25">
                  <md-field>
                    <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                      <md-option value="">{{$I18n("currency")}}</md-option>
                      <md-option v-for="item in assi_final_attrOption(formItem.key)" :key="item" :value="item" >
                        {{item}}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-65">
                  <!-- INPUT -->
                  <md-field>
                    <md-input v-model="formItem.value"/>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-10">
                  <md-button 
                    @click="assiData.Form._final_price_list.splice(index,1)" 
                    :style="{'float':'right'}"
                    class="md-primary md-sm md-info right-button md-just-icon md-round"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </simple-modal>
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "openModalType!=='delete' && openModalType!=='sub-delete'"
      :large = "openModalType!=='delete' && openModalType!=='sub-delete'"
      @submit= "modal_submit"
      @close = "closeModal"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.name)}}</div>
        <div v-else-if="openModalType==='sub-delete'">{{$I18n("check_delete", modalSubData.Form.name)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else-if="openModalType === 'add' || openModalType === 'edit'" class="md-layout">
          <!-- 图片 -->
          <modal-form-item  class="md-layout-item md-size-100" :label='$I18n("icon")'>
            <div class="file-input">
              <div v-if="!imageRegular">
                <div @click="clickInput" class="image-container" :style="{'box-shadow': 'none'}">
                  <img :src="regularImg" title="" />
                </div>
              </div>
              <div @click="clickInput" class="image-container" :style="{'box-shadow': 'none'}" v-else>
                <img :src="imageRegular" />
              </div>
              <div>
                <md-button class="md-info md-round md-fileinput">
                  <template v-if="!imageRegular">{{$I18n("upload_img")}}</template>
                  <template v-else>{{$I18n("upload_img")}}</template>
                  <input ref="file_input" type="file" @change="onFileChange" />
                </md-button>
              </div>
            </div>
          </modal-form-item>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
          <!-- 子部分 -->
          <div class="md-layout-item md-layout md-size-100">
            <template v-if="openModalType !== 'edit'">
              <!--  -->
              <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left','margin-top': '30px','display':'flex'}">
                <span class="md-form-label" style="padding-top: 0;">{{$I18n("cost_price")}}<i style="color: red;">*</i></span>
                <div @click="modalData.Form._cost_price_list.push({key:'',value:''})" :style="{'background':'#FFF','cursor': 'pointer','margin-left':'10px'}">
                  <icon-add/>
                </div>
              </div>
              <div class="md-layout-item md-size-33" v-for="(formItem, index) in modalData.Form._cost_price_list" :key="'cost' + index" style="margin-left: 0 !important;">
                <md-card :style="{'margin-bottom':'5px'}">
                  <md-card-content>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-35">
                        <md-field>
                          <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                            <md-option value="">{{$I18n("currency")}}</md-option>
                            <md-option v-for="item in cost_attrOption(formItem.key)" :key="item" :value="item" >
                              {{item}}
                            </md-option>
                          </md-select>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-55">
                        <!-- INPUT -->
                        <md-field>
                          <md-input v-model="formItem.value"/>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-10">
                        <md-button 
                          @click="modalData.Form._cost_price_list.splice(index,1)" 
                          :style="{'float':'right'}"
                          class="md-primary md-sm md-info right-button md-just-icon md-round"
                        >
                          <md-icon>close</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <!--  -->
              <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left','margin-top': '30px','display':'flex'}">
                <span class="md-form-label" style="padding-top: 0;">{{$I18n("list_price")}}<i style="color: red;">*</i></span>
                <div @click="modalData.Form._list_price_list.push({key:'',value:''})" :style="{'background':'#FFF','cursor': 'pointer','margin-left':'10px'}">
                  <icon-add/>
                </div>
              </div>
              <div class="md-layout-item md-size-33" v-for="(formItem, index) in modalData.Form._list_price_list" :key="'list' + index" style="margin-left: 0 !important;">
                <md-card :style="{'margin-bottom':'5px'}">
                  <md-card-content>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-35">
                        <md-field>
                          <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                            <md-option value="">{{$I18n("currency")}}</md-option>
                            <md-option v-for="item in list_attrOption(formItem.key)" :key="item" :value="item" >
                              {{item}}
                            </md-option>
                          </md-select>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-55">
                        <!-- INPUT -->
                        <md-field>
                          <md-input v-model="formItem.value"/>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-10">
                        <md-button 
                          @click="modalData.Form._list_price_list.splice(index,1)" 
                          :style="{'float':'right'}"
                          class="md-primary md-sm md-info right-button md-just-icon md-round"
                        >
                          <md-icon>close</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <!--  -->
              <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left','margin-top': '30px','display':'flex'}">
                <span class="md-form-label" style="padding-top: 0;">{{$I18n("retail_price")}}<i style="color: red;">*</i></span>
                <div @click="modalData.Form._final_price_list.push({key:'',value:''})" :style="{'background':'#FFF','cursor': 'pointer','margin-left':'10px'}">
                  <icon-add/>
                </div>
              </div>
              <div class="md-layout-item md-size-33" v-for="(formItem, index) in modalData.Form._final_price_list" :key="'final' + index" style="margin-left: 0 !important;">
                <md-card :style="{'margin-bottom':'5px'}">
                  <md-card-content>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-35">
                        <md-field>
                          <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                            <md-option value="">{{$I18n("currency")}}</md-option>
                            <md-option v-for="item in final_attrOption(formItem.key)" :key="item" :value="item" >
                              {{item}}
                            </md-option>
                          </md-select>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-55">
                        <!-- INPUT -->
                        <md-field>
                          <md-input v-model="formItem.value"/>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-10">
                        <md-button 
                          @click="modalData.Form._final_price_list.splice(index,1)" 
                          :style="{'float':'right'}"
                          class="md-primary md-sm md-info right-button md-just-icon md-round"
                        >
                          <md-icon>close</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </template>

            <!-- 属性 -->
            <!-- 添加一个新的 -->
            <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left', 'margin-top': '30px'}">
              <md-button class="md-info" @click="modalData.Form.attrArray.push({key:'',value:''})">{{$I18n("add_attr")}}</md-button>
            </div>
            <div class="md-layout-item mx-auto md-size-50" v-for="(formItem, index) in modalData.Form.attrArray" :key="'attr'+index" style="margin-left: 0 !important;">
              <md-card :style="{'margin-bottom':'5px'}">
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-35">
                      <md-field>
                        <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                          <md-option value="">{{$I18n("attr")}}</md-option>
                          <md-option v-for="item in attrOption(formItem.key)" :key="item.key" :value="item.key" >
                            {{item.name}}
                          </md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-55">
                      <md-field v-if="attr_value(formItem.key).length > 0">
                        <md-select v-model="formItem.value">
                          <md-option value="">{{$I18n("attr_value")}}</md-option>
                          <md-option v-for="item in attr_value(formItem.key)" :key="item" :value="item">
                            {{(parseInt(searchForm) === 101 && formItem.key === "type") 
                              ? $I18n($Param.videoGoodType.getName(item))
                              :item
                            }}
                          </md-option>
                        </md-select>
                      </md-field>
                      <!-- INPUT -->
                      <md-field v-else>
                        <md-input v-model="formItem.value"/>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-10">
                      <md-button 
                        @click="modalData.Form.attrArray.splice(index,1)" 
                        :style="{'float':'right'}"
                        class="md-primary md-sm md-info right-button md-just-icon md-round"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass, timestampToString1000,copyObj } from "@/common/tools.js";
import IconAdd from "@/components/IconSvg/IconAdd.vue";
export default {
  components: {
    IconAdd
  },
  data() {
    return {
      
      searchFormCompany : 0,
      searchForm:"",

      imageRegular : "",
      regularImg : "/img/image_placeholder.jpg",

      // 表格相关
      tableData : [], // 表格数据
      // 是否打开弹窗
      openModalType : "add", // "delete" | "edit" | "sub-add" | "sub-edit" | "sub-delete"
      // 弹窗相关
      modalTitle : "",
      error: {
        name: false,
      },
      modalData     : new FormClass({
        name        : "",
        class_name  : "",
        comp_path   : "",
        sort        : 0,
        state       : 1,
        month       : 0,
        // inr_price : "",
        // inr_fact_price  : "",
        // usd_price : "",
        // usd_fact_price  : "",
        // rmb_price : "",
        // rmb_fact_price  : "",
        link_type   : 1,
        only        : 2,
        type        : 2,
        limit       : 2,
        is_pay_disc : 1,
        stock       : "",
        other_id    : "",
        stripe_id   : "",
        razorpay_id : "",
        paypal_pid  : "",
        apple_pid   : "",
        // owner_id    : this.UserInfo.user_id,
        comp_cn_price : "",
        comp_other_price: "",
        img        : "",
        promotion_code: "",
        attrArray  : () => {return []},
        _cost_price_list: () => {return [{key:"", value:""}]},
        _list_price_list: () => {return [{key:"", value:""}]},
        _final_price_list: () => {return [{key:"", value:""}]},
      },{
        month        : "number",
        name         : "required",
        stock : (val, formValue) => {
          if(formValue.limit === 1){
            return isNaN(val)
          } else {
            return false;
          }
        },
        _cost_price_list: (val) => {
          return !val.some(i => !!i.key && !isNaN(i.value) && parseFloat(i.value) >= 0)
        },
        _list_price_list: (val) => {
          return !val.some(i => !!i.key && !isNaN(i.value) && parseFloat(i.value) >= 0)
        },
        _final_price_list: (val) => {
          return !val.some(i => !!i.key && !isNaN(i.value) && parseFloat(i.value) >= 0)
        },
      }),
      compData : [],
      subCompData: [],
      otherPlatData: [],
      classData: [],
      currentPage : 1,
      pageSize : 10,
      total : 0,

      init : false,

      // 点击table弹窗(修改单个key)
        keyItem: {},
        keyInput: "",
        keyList: [],
        keyModalType: "",
        keyTitle: "",
        m_type : [
          "USD",
          "CNY",
          "INR",
          "IDR",
        ],

      // 分配商品
        assi_comp:"",
        assiDataBase:{},
        assiDataBase_v2:[],
        assiData: new FormClass({
          comp_path: "",
          _state_name: false,
          _cost_price_list: () => {return []},
          _list_price_list: () => {return []},
          _final_price_list: () => {return []},
        },{
          _cost_price_list: (val) => {
            return !val.some(i => !!i.key && !isNaN(i.value) && parseFloat(i.value) >= 0)
          },
          _list_price_list: (val) => {
            return !val.some(i => !!i.key && !isNaN(i.value) && parseFloat(i.value) >= 0)
          },
          _final_price_list: (val) => {
            return !val.some(i => !!i.key && !isNaN(i.value) && parseFloat(i.value) >= 0)
          },
        }),

      // 商品分配表单
        alloInfo:{},
        alloPageNo:1,
        alloPageSize:10,
        alloTableData:[],
        alloTotal:0,
        alloLoad:false,
    };
  },
  mounted : function() {
    // this.api_getPageData();
    this.api_getCompany ()
      .then(() => {
        this.searchFormCompany = this.UserInfo.comp_id;
      })
      .then(() => {
        return this.api_getClass ()
          .then(() =>{
            if(this.classData.length == 0){
              return;
            }
            this.searchForm = this.classData[0].id;
            setTimeout(() => {
              this.api_getPageData ();
              this.init = true;
            }, 100);
          });
      });
    this.api_otherPlatform ();
  },
  watch: {
    currentPage(){
      this.api_getPageData();
    },
    alloPageNo(){
      this.api_allo_getDate();
    },
    modalData:{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    searchFormCompany(){
      if(this.init){
        this.api_getPageData();
      }
    },
    searchForm(){
      if(this.init){
        this.api_getPageData();
      }
    },
  },
  computed: {
    assiComp(){
      return this.subCompData.filter(i => i.path != this.assi_comp).map(i => ({
        id  : i.path,
        name: i.comp_name,
      }))
    },
    attrData(){
      const item = this.classData.filter(i => i.id == this.searchForm)[0]
      if(!item){
        return []
      }
      return JSON.parse(item.attr)
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("class_name"),
          keys    : "class_name",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-50",
        // },{
        //   label   : this.$I18n("seller_id"),
        //   keys    : "owner_id",
        //   type    : "input",
        //   disabled: this.UserInfo.role_id >= 10000,
        //   required: true,
        //   check   : true,
        //   class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("company"),
          keys    : "comp_path",
          type    : "select",
          disabled: this.UserInfo.role_id >= 10000 || this.openModalType === 'edit',
          placeholder:this.$I18n('pls_input_role_id'),
          class   : "md-layout-item md-size-50",
          options : this.compData.map(i => {
            return {
              id  : i.path,
              name: i.comp_name,
            }
          })
        },{
          label   : this.$I18n("effect_month"),
          keys    : "month",
          type    : "input",
          disabled: this.UserInfo.role_id >= 10000,
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("sort_num"),
          keys    : "sort",
          type    : "input",
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("sales_num"),
          keys    : "sales",
          type    : "input",
          hide    : this.openModalType !== 'edit',
          disabled: true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("stock_state"),
          keys    : "state",
          type    : "select",
          options : [
            {id: 1, name :this.$I18n("upper_shelf")},
            {id: 2, name :this.$I18n("lower_shelf")},
          ],
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("only_sale_one"),
          keys    : "only",
          type    : "select",
          disabled: this.UserInfo.role_id >= 10000,
          options : [
            {id: 1, name :this.$I18n("open")},
            {id: 2, name :this.$I18n("close")},
          ],
          class   : "md-layout-item md-size-25",
        },{
        //   label   : this.$I18n("comp_price"),
        //   keys    : "comp_cn_price",
        //   type    : "input",
        //   disabled: this.UserInfo.role_id >= 10000,
        //   class   : "md-layout-item md-size-25",
        // },{
        //   label   : this.$I18n("comp_other_price"),
        //   keys    : "comp_other_price",
        //   type    : "input",
        //   disabled: this.UserInfo.role_id >= 10000,
        //   class   : "md-layout-item md-size-25",
        // },{
          label   : this.$I18n("limit_stock_num"),
          keys    : "limit",
          type    : "select",
          options : [
            {id: 2, name :this.$I18n("unlimit")},
            {id: 1, name :this.$I18n("have_limit")},
          ],
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("stock_num"),
          keys    : "stock",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("good_type"),
          keys    : "link_type",
          type    : "select",
          options : [
            {id : 1, name : this.$I18n("single_mode")},
            {id : 2, name : this.$I18n("user_mod")}
          ],
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("bind_other_order_id"),
          keys    : "other_id",
          type    : "select",
          options : [
            {id : "", name : this.$I18n("un_bind")},
            ...this.otherPlatData.map(i => {
              return {
                id  : i.id,
                name: i.name,
              }
            })
          ],
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("stripe_price_id"),
          keys    : "stripe_id",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("razorpay_plan_id"),
          keys    : "razorpay_id",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("paypal_plan_id"),
          keys    : "paypal_pid",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("apple_pay_id"),
          keys    : "apple_pid",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("google_pay_id"),
          keys    : "google_pid",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("promo_code"),
          keys    : "promotion_code",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("is_pay_disc"),
          keys    : "is_pay_disc",
          type    : "select",
          options : [
            {id : 1, name : this.$I18n("open")},
            {id : 2, name : this.$I18n("closed")}
          ],
          class   : "md-layout-item md-size-25",
        }
      ]
    },
  },
  methods: {
    api_allo_getDate(newPage){
      if(this.alloLoad){
        return
      }
      this.alloLoad = true;
      if(newPage){
        this.alloPageNo = newPage
      } 
      return this.$api.getGood({ 
        is_sub_comp: 1,
        product_id : this.alloInfo.id,
        comp_path  : this.alloInfo.comp_path,
        page_index : this.alloPageNo,
        page_size  : this.alloPageSize,
      })
        .then(res => {
          this.alloTableData = [...res.data].map(this.buildGoodTableData);
          this.alloTotal = res.count;
        })
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.alloTableData = [];
          this.alloTotal = 0;
        }))
        .then(() => {
          this.alloLoad = false;
        })
    },
    allo_item(item){
      this.alloInfo = copyObj(item);
      this.api_allo_getDate(1);
      this.$refs.allo_modal.open();
    },
    assi_submit(){
      if(this.assiData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }

      var cost_p = {};
      for(var cost_index =0; cost_index < this.assiData.Form._cost_price_list.length; cost_index++) {
        let item = this.assiData.Form._cost_price_list[cost_index];
        if(!item.key || !item.value || isNaN(item.value) || parseFloat(item.value) < parseFloat(this.assiDataBase._cost_price_list.filter(
            (base_item) => base_item.key === item.key
          )[0].value)){
          this.$errorMsg(this.$I18n("cost_price_lower"))
          return
        }
        cost_p[item.key] = item.value
      }
      this.assiData.Form._cost_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        cost_p[i.key] = i.value.replace(/^ | /g, "")
      })
      
      var list_p = {};
      this.assiData.Form._list_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        list_p[i.key] = i.value.replace(/^ | /g, "")
      })
      var final_p = {};
      this.assiData.Form._final_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        final_p[i.key] = i.value.replace(/^ | /g, "")
      })
      this.$api.assiGood({
        ...this.assiData.Form,
        product_id: this.assiData.Form.id,
        state: this.assiData.Form._state_name ?1 :2,
        cost_price: JSON.stringify(cost_p),
        list_price: JSON.stringify(list_p),
        final_price: JSON.stringify(final_p),
      })
        .then(this.$Then(res => {
          if(res.code == 3013){
            this.$errorMsg(this.$I18n("error_code_3013"))
            return
          } else if(res.code == 3014){
            this.$errorMsg(this.$I18n("error_code_3014"))
            return
          } else if(res.code == 3015){
            this.$errorMsg(this.$I18n("error_code_3015"))
            return
          } else if(res.code == 3016){
            this.$errorMsg(this.$I18n("cost_price_lower"));
            return
          } else if(res.code == 3018){
            this.$errorMsg(this.$I18n("error_code_3018"));
            return
          }
          this.$successMsg(this.$I18n("edit_success"));
          this.api_getPageData();
          this.$refs.assi_modal.close();
        }, [3013, 3014, 3015, 3018, 3016]))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    assi_cost_attrOption(key){
      return this.m_type.filter(attr => {
        return attr == key || !this.assiData.Form._cost_price_list.some(item => item.key == attr)
      })
    },
    assi_list_attrOption(key){
      return this.m_type.filter(attr => {
        return attr == key || !this.assiData.Form._list_price_list.some(item => item.key == attr)
      })
    },
    assi_final_attrOption(key){
      return this.m_type.filter(attr => {
        return attr == key || !this.assiData.Form._final_price_list.some(item => item.key == attr)
      })
    },
    assi_item(item){
      this.assi_comp = item.path;
      this.$api.getCompanyList({only_sub: 1})
        .then(this.$Then(res => {
          this.subCompData = res.data;
          setTimeout(() => {
            this.assiDataBase = {...item};
            this.assiData.Update_v2({
              ...item,
              comp_path: this.assiComp[0].id,
            });
            this.$refs.assi_modal.open();
          }, 0)
      }))
      .catch(this.$Catch(this.$I18n("get_error"), () => {
        this.subCompData = [];
      }))
    },
    changeItem(item, key, title, spMode){
      this.keyItem = copyObj(item);
      this.keyModalType = key;
      if(key == "name" || key == "custom_name"){
        this.keyInput = item[key];
      } else{
        this.keyList = copyObj(item[`_${key}_list`]);
      }
      this.keyTitle = title;
      this.assiDataBase_v2 = spMode ?spMode :[];
      this.$refs.key_modal.open();
    },
    key_submit(){
      var data = {...this.keyItem};
      // 校验
      if(this.keyModalType == "name" || this.keyModalType == "custom_name"){
        if(!this.keyInput){
          this.$errorMsg(this.$I18n("illegal_param"));
          return
        }
        data[this.keyModalType] = this.keyInput
      }else{
        // 构建JSON
        var res = {};
        this.keyList.forEach(item => {
          if(item.key && item.value && !isNaN(item.value) && parseFloat(item.value) >= 0){
            res[item.key] = item.value.replace(/^ | /g, "");
          }
        })
        if(Object.keys(res).length == 0){
          this.$errorMsg(this.$I18n("illegal_param"));
          return
        }
        data[this.keyModalType] = JSON.stringify(res);
      }
      if(this.assiDataBase_v2){
        if(this.assiDataBase_v2.some(item => {
          return parseFloat(item.value) > parseFloat(res[item.key]? res[item.key] :0)
        })){
          this.$errorMsg(this.$I18n("cost_price_lower"))
          return
        }
      }
      // 请求
      this.$api.editGood({
        ...data,
        type: 3,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          if(this.alloInfo.id){
            this.api_allo_getDate();
          } else {
            this.api_getPageData();
          }
          this.$refs.key_modal.close();
          this.assiDataBase_v2 = [];
        }))
        .catch((err) => {
          if(err.code === 3016){
            this.$errorMsg(this.$I18n("cost_price_lower"))
            return
          } else if(err.code == 3018){
            this.$errorMsg(this.$I18n("error_code_3018"));
            return
          } else {
            this.$Catch(this.$I18n("edit_fail"))(err)
          }
        })
    },

    key_attrOption(key){
      return this.m_type.filter(attr => {
        return attr == key || !this.keyList.some(item => item.key == attr)
      })
    },
    cost_attrOption(key){
      return this.m_type.filter(attr => {
        return attr == key || !this.modalData.Form._cost_price_list.some(item => item.key == attr)
      })
    },
    list_attrOption(key){
      return this.m_type.filter(attr => {
        return attr == key || !this.modalData.Form._list_price_list.some(item => item.key == attr)
      })
    },
    final_attrOption(key){
      return this.m_type.filter(attr => {
        return attr == key || !this.modalData.Form._final_price_list.some(item => item.key == attr)
      })
    },

    // 切换商品状态
    switchState(data){
      this.$api.editGood({
        ...data,
        state: data._state_name ?2 :1,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.api_getPageData();
        }))
        .catch((err) => {
          if(err.code === 3016){
            this.$errorMsg(this.$I18n("cost_price_lower"))
            return
          } else if(err.code == 3018){
            this.$errorMsg(this.$I18n("error_code_3018"));
            return
          } else {
            this.$Catch(this.$I18n("edit_fail"))(err)
          }
        })
    },
    switchBoldState(data){
      this.$api.editGood({
        ...data,
        state: data._state_name ?2 :1,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.api_allo_getDate();
        }))
        .catch((err) => {
          if(err.code === 3016){
            this.$errorMsg(this.$I18n("cost_price_lower"))
            return
          } else if(err.code == 3018){
            this.$errorMsg(this.$I18n("error_code_3018"));
            return
          } else {
            this.$Catch(this.$I18n("edit_fail"))(err)
          }
        })
    },
    get_comp_path(comp_id){
      const compInfo = this.compData.filter(i => i.comp_id == comp_id)[0];
      if(compInfo){
        return compInfo.path;
      }
      return ""
    },
    closeModal (){
      document.getElementsByTagName("body")[0].style = ""
    },
    changedKey(formItem){
      formItem.value="";
    },
    attrOption(key){
      return this.attrData.filter(attr => {
        return attr.key == key || !this.modalData.Form.attrArray.some(item => item.key == attr.key)
      })
    },
    attr_value (key) {
      if(!key) {
        return [];
      }
      try {
        var list = this.attrData.filter(item => {
          return item.key == key;
        })[0].value;
        if(list.length === 1 && list[0] == -1){
          return []
        }
        return list
      } catch (e) {
        return [];
      }
    },
    ...({ // 上传图片相关
      onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files  || !files.length) return;
        let reader = new FileReader();
        let vm = this;
        reader.onload = (e) => {
          vm.imageRegular = e.target.result;
        };

        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            this.modalData.Form.img = res.data;
            reader.readAsDataURL(files[0]);
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      },
      clickInput(){
        this.$refs.file_input.click();
      },
    }),
    api_getCompany (){
      return this.$api.getCompanyList({ })
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.compData = [];
        }))
    },
    api_otherPlatform (){
      this.$api.getOtherPlatform({type :0 })
        .then(this.$Then(res => {
          this.otherPlatData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.otherPlatData = [];
        }))
    },
    api_getClass (){
      return this.$api.getGoodClass({ })
        .then(this.$Then(res => {
          this.classData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.classData = [];
        }))
    },
    // 获取页面信息
    api_getPageData(){
      //获取菜单
      return this.$api.getGood({ 
        comp_id  : this.searchFormCompany === "__ALL__" ?"" :this.searchFormCompany,
        comp_path:this.get_comp_path(this.searchFormCompany === "__ALL__" ?"" :this.searchFormCompany),
        category_id: this.searchForm,
        seller_id : '',
        page_index : this.currentPage,
        page_size : this.pageSize,
        app_id: '',
        is_spec: 2,
      })
        .then(this.$Then(res => {
          this.tableData = [...res.data].map(this.buildGoodTableData);
          this.total = res.count;
        }))

        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableData = [];
          this.total = 0;
        }))
    },
    buildGoodTableData(item){
      try{
        let companyData = this.compData.filter(comp => {
          return comp.path == item.comp_path;
        })
        let comp_name = "";
        if(companyData.length > 0){
          comp_name = companyData[0].comp_name
        }
        let class_name = this.classData.filter(item => {
          return item.id == this.searchForm;
        })[0].name
        let attrArray = [];
        if(item.attr){
          let attrJSON = JSON.parse(item.attr)
          for(let key in attrJSON){
            attrArray.push({
              key: key,
              value: attrJSON[key],
            })
          }
        }
        var cost_price_list = [];
        if(item.cost_price){
          const cost_price_json = JSON.parse(item.cost_price);
          for(var cost_key in cost_price_json){
            cost_price_list.push({key: cost_key, value: cost_price_json[cost_key]})
          }
        }
        var list_price_list = [];
        if(item.list_price){
          const list_price_json = JSON.parse(item.list_price);
          for(var list_key in list_price_json){
            list_price_list.push({key: list_key, value: list_price_json[list_key]})
          }
        }
        var final_price_list = [];
        if(item.final_price){
          const final_price_json = JSON.parse(item.final_price);
          for(var final_key in final_price_json){
            final_price_list.push({key: final_key, value: final_price_json[final_key]})
          }
        }
        var state_name = item.state == 1;
        return {
          ...item,
          _comp_name: comp_name,
          class_name,
          attrArray,
          _cost_price_list : cost_price_list,
          _list_price_list : list_price_list,
          _final_price_list : final_price_list,
          _state_name: state_name,
          create_time: timestampToString1000(item.gmt_create),
        }
      }catch{
        return {}
      }
    },
    handleCommand(command, item){
      if(command == 'edit'){
        this.table_editItem(item)
      } else if(command == 'assi'){
        this.assi_item(item);
      } else if(command == 'allo'){
        this.allo_item(item);
      }
    },
    // 新增角色
    table_addItem  (){
      this.modalTitle = this.$I18n("add_good");
      this.openModalType = "add";
      this.modalData.Reset();
      if(this.searchFormCompany){
        this.modalData.Form.comp_path = this.compData.filter(i => i.comp_id == this.searchFormCompany)[0]?.path ?? "";
      } else {
        this.modalData.Form.comp_path = this.compData[0].path;
      }
      let fir_class = this.classData.filter(item => item.id == this.searchForm)[0];
      if(!fir_class) {
        this.$errorMsg(this.$I18n("pls_add_good_class"));
        return
      }
      this.modalData.Form.class_name = this.classData.filter(item => item.id == this.searchForm)[0].name;
      this.imageRegular = ""
      this.regularImg = "/img/image_placeholder.jpg"
      this.$refs.modal.open();
      document.getElementsByTagName("body")[0].style = "overflow: hidden;"
    },
    // 修改角色
    table_editItem (item){
      this.modalTitle = this.$I18n("edit_good");
      this.openModalType = "edit";
      this.modalData.Update_v2({
        ...item,
        sort : item.sort ?item.sort :0,
        other_id : item.other_id ?item.other_id :"",
      });
      this.$refs.value  = this.modalData.Form.img;
      this.imageRegular = this.modalData.Form.img;
      this.$refs.modal.open();
      document.getElementsByTagName("body")[0].style = "overflow: hidden;"
    },
    // 删除角色
    table_deleteItem (item){
      this.modalTitle = this.$I18n("is_sure_del");
      this.openModalType = "delete";
      this.modalData.Update(item);
      this.$refs.modal.open();
      document.getElementsByTagName("body")[0].style = "overflow: hidden;"
    },
    // 提交表单
    modal_submit () {
      if(this.openModalType === "delete"){
        this.modal_submitDel();
      } else if (this.openModalType === "add") {
        this.modal_submitAdd();
      } else if (this.openModalType === "edit"){
        this.modal_submitEdit();
      } else if (this.openModalType === "sub-add") {
        this.modal_submitSubAdd();
      } else if (this.openModalType === "sub-edit"){
        this.modal_submitSubEdit();
      } else if (this.openModalType === "sub-delete"){
        this.modal_submitSubDel();
      }
    },
    modal_submitAdd () {
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      let attr  = {}
      this.modalData.Form.attrArray.forEach(item => {
        if(item.value){
          attr[item.key] = item.value;
        }
      });
      if(isNaN(this.modalData.Form.comp_cn_price) || this.modalData.Form.comp_cn_price === ""){
        this.modalData.Form.comp_cn_price = "0.00";
      }
      if(isNaN(this.modalData.Form.comp_other_price) || this.modalData.Form.comp_other_price === ""){
        this.modalData.Form.comp_other_price = "0.00";
      }
      var cost_p = {};
      this.modalData.Form._cost_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        cost_p[i.key] = i.value.replace(/^ | /g, "")
      })
      var list_p = {};
      this.modalData.Form._list_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        list_p[i.key] = i.value.replace(/^ | /g, "")
      })
      var final_p = {};
      this.modalData.Form._final_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        final_p[i.key] = i.value.replace(/^ | /g, "")
      })
      this.$api.addGood({
        ...this.modalData.Form,
        // comp_path: this.compData.filter(i => i.comp_id == this.modalData.Form.comp_id)[0]?.path ?? "",
        cost_price: JSON.stringify(cost_p),
        list_price: JSON.stringify(list_p),
        final_price: JSON.stringify(final_p),
        type: 3,
        category_id : this.searchForm,
        attr: JSON.stringify(attr),
      })
        .then(this.$Then(res => {
          this.modalData.Form.id = res.data.id;
          this.$successMsg(this.$I18n("add_success"));
          this.$refs.modal.close();
          this.api_getPageData();
        }))
        .catch((err) => {
          if(err.code === 3016){
            this.$errorMsg(this.$I18n("cost_price_lower"))
            return
          } else if(err.code == 3018){
            this.$errorMsg(this.$I18n("error_code_3018"));
            return
          } else {
            this.$Catch(this.$I18n("add_fail"))(err)
          }
        })
    },
    modal_submitEdit () {
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      let attr  = {}
      this.modalData.Form.attrArray.forEach(item => {
        if(item.value){
          attr[item.key] = item.value;
        }
      })
      if(isNaN(this.modalData.Form.comp_cn_price) || this.modalData.Form.comp_cn_price === ""){
        this.modalData.Form.comp_cn_price = "0.00";
      }
      if(isNaN(this.modalData.Form.comp_other_price) || this.modalData.Form.comp_other_price === ""){
        this.modalData.Form.comp_other_price = "0.00";
      }
      var cost_p = {};
      this.modalData.Form._cost_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        cost_p[i.key] = i.value.replace(/^ | /g, "")
      })
      var list_p = {};
      this.modalData.Form._list_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        list_p[i.key] = i.value.replace(/^ | /g, "")
      })
      var final_p = {};
      this.modalData.Form._final_price_list.map(i => {
        if(!i.key || !i.value || isNaN(i.value) || parseFloat(i.value) < 0){
          return
        }
        final_p[i.key] = i.value.replace(/^ | /g, "")
      })
      this.$api.editGood({
        ...this.modalData.Form,
        cost_price: JSON.stringify(cost_p),
        list_price: JSON.stringify(list_p),
        final_price: JSON.stringify(final_p),
        type: 3,
        attr: JSON.stringify(attr),
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.modal.close();
          this.api_getPageData();
        }))
        .catch(err => {
          if(err.code === 3016){
            this.$errorMsg(this.$I18n("cost_price_lower"))
            return
          } else if(err.code == 3018){
            this.$errorMsg(this.$I18n("error_code_3018"));
            return
          } else {
            this.$Catch(this.$I18n("edit_fail"))(err)
          }
        })
    },
    modal_submitDel (){
      this.$api.delGood({
        ...this.modalData.Form,
      })
        .then(this.$Then(res => {
          if(this.alloTableData.length > 0){
            this.api_allo_getDate(1);
          }
          if(res.code == "1024"){
            this.$errorMsg(this.$I18n("error_code_1024"));
            this.$refs.modal.close();
            this.api_getPageData();
            return 
          }
          this.$successMsg(this.$I18n("delete_success"));
          this.$refs.modal.close();
          this.api_getPageData();
        },["1024"]))
        .catch(this.$Catch(this.$I18n("delete_fail")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .allo_item{
    flex: 1;
    max-width: 33.33%;
    min-width: 33.33%;
    margin-top:10px;
  }
  .allo_label{
    display: inline-block;
    width: 100px;
    font-size: 16px;
    font-weight: 600;
    color: #adadad;
    margin-bottom: 5px;
  }
  .unselect-box{
    width : 28px;
    height: 28px;
    border: 2px solid #9c27b0 !important;
    border-radius: 4px;
  }
  .modalTable {
    text-align: left !important;
  }
  modalTable:hover{
    cursor: pointer;
  }
  .md-layout {
    overflow: hidden;
  }
  // 弹窗内组件

  //表格里的多选框
    .checkbox-color{
      color: #9c27b0  !important;
    }
    .table-checkbox {
      width: 80px;
    }
    .table-checkbox  .md-checkbox{
      margin: 0;
    }
    .table-selected{
      text-align: left;
      width: 100%;
    }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗的表单
  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px ;
    text-align: left;
  }
  .md-layout-left{
    text-align: left;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 100px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon {
    margin-right: 20px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>